import React from "react";
import { formatINR, formatNumber, formatDate } from "@/lib/format";

function fmt(value, type) {
  if (value === null || value === undefined || value === "") return "—";
  if (type === "currency") return formatINR(value);
  if (type === "number") return formatNumber(value);
  if (type === "percent") return `${Number(value).toFixed(1)}%`;
  if (type === "date") return formatDate(value);
  return value;
}

export function SummaryCards({ summary }) {
  if (!summary) return null;
  const cards = summary.cards || [];
  const groups = summary.groups || [];
  return (
    <div className="space-y-5" data-testid="report-summary">
      {cards.length > 0 && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {cards.map((c, i) => (
            <div key={i} className="bg-white border border-slate-200 rounded-md p-4" data-testid={`summary-card-${i}`}>
              <div className="label-eyebrow !text-slate-400">{c.label}</div>
              <div className="font-mono-num text-2xl font-bold text-slate-900 mt-1">{fmt(c.value, c.format)}</div>
            </div>
          ))}
        </div>
      )}
      {groups.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {groups.map((g, gi) => (
            <div key={gi} className="bg-white border border-slate-200 rounded-md p-4" data-testid={`summary-group-${gi}`}>
              <div className="label-eyebrow !text-slate-500 mb-2">{g.title}</div>
              <div className="space-y-1.5">
                {g.rows.map((r, ri) => (
                  <div key={ri} className="flex items-center justify-between text-sm">
                    <span className="text-slate-700">{r.label}</span>
                    <span className="flex items-center gap-3">
                      <span className="font-mono-num font-semibold text-slate-900">{r.count}</span>
                      {r.sum !== undefined && (
                        <span className="font-mono-num text-xs text-slate-500 w-28 text-right">{formatINR(r.sum)}</span>
                      )}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function ReportTable({ columns = [], rows = [] }) {
  return (
    <div className="bg-white border border-slate-200 rounded-md overflow-hidden" data-testid="report-table">
      <div className="overflow-x-auto scrollbar-thin">
        <table className="data-table w-full">
          <thead>
            <tr>
              {columns.map((c) => (
                <th key={c.key} className={`label-eyebrow !text-slate-600 ${["currency", "number", "percent"].includes(c.type) ? "text-right" : ""}`}>
                  {c.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={columns.length} className="text-center py-10 text-sm text-slate-500" data-testid="report-table-empty">No results for the selected filters.</td></tr>
            ) : rows.map((r, i) => (
              <tr key={i} className="border-t border-slate-100" data-testid={`report-row-${i}`}>
                {columns.map((c) => (
                  <td key={c.key} className={`text-sm text-slate-800 ${["currency", "number", "percent"].includes(c.type) ? "text-right font-mono-num" : ""}`}>
                    {fmt(r[c.key], c.type)}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
